import React from "react";

const variants = {
    running: { bg: "rgba(43,227,139,0.14)", color: "#2BE38B", border: "rgba(43,227,139,0.25)", dot: "#2BE38B" },
    stopped: { bg: "rgba(255,92,108,0.14)", color: "#FF5C6C", border: "rgba(255,92,108,0.25)", dot: "#FF5C6C" },
    paper: { bg: "rgba(61,167,255,0.14)", color: "#3DA7FF", border: "rgba(61,167,255,0.25)", dot: "#3DA7FF" },
    live: { bg: "rgba(255,176,32,0.14)", color: "#FFB020", border: "rgba(255,176,32,0.25)", dot: "#FFB020" },
    info: { bg: "rgba(167,180,198,0.10)", color: "#A7B4C6", border: "rgba(167,180,198,0.20)", dot: "#A7B4C6" },
    accent: { bg: "rgba(46,230,214,0.14)", color: "#2EE6D6", border: "rgba(46,230,214,0.25)", dot: "#2EE6D6" },
};

export const StatusPill = ({ variant = "info", children, withDot = false, testId }) => {
    const v = variants[variant] || variants.info;
    return (
        <span
            data-testid={testId}
            className="inline-flex items-center gap-1.5 h-6 px-2.5 rounded-full text-[10px] uppercase tracking-[0.14em] font-medium select-none"
            style={{ background: v.bg, color: v.color, border: `1px solid ${v.border}` }}
        >
            {withDot && <span className="pulse-dot" style={{ background: v.dot }} />}
            {children}
        </span>
    );
};

export default StatusPill;
